import { Component, OnInit, ViewContainerRef, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { Helper } from '../helpers/helper';
import { LocalstorageService } from '../localstorage.service';

@Component({
  selector: 'echxpayment-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.css'],
  providers: [Modal]
})
export class PlanComponent implements OnInit {
	public plan= <any>{};
	public token: string;
	show: boolean = true;
	busy: Subscription;

	public data;
	public filterQuery = "";
	public rowsOnPage = 10;
	public sortBy = "plan_name";
	public sortOrder = "asc";

	public dataNotFound = false;
	constructor(private router: Router, vcRef: ViewContainerRef, private renderer: Renderer2, public modal: Modal, private toastr: ToastrService, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService) { 

	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;


	}

	ngOnInit() {
		this.getAllPlan();
	}

	// list all plan
	getAllPlan(){
		var data = {
			token:this.token,
		}
		var url =  this.router.url
		if(url ==='/plan' ){
		let responseData = <any>{};
		 this.busy = this.echexpaymentService.getAllPlan(data).subscribe(
			 response => {
				responseData = response;
				this.data = responseData.data.data;
				
			   if(this.data.length == 0){
				 this.dataNotFound =  responseData.message
			   }
			 },
			 error => {
			  responseData = error;
			  this.toastr.error(responseData.error.message, 'Failed!');
			 }
		  );
		}
	}
	// delete plan by id
	deletePlan(event,plan_id){
		let responseData = <any>{};	
		event.stopPropagation();
		  this.modal.confirm()
			.size('sm')
			.title('CasherPay')
			.body(`Are you sure to delete this plan.`)
			.okBtn('Okay')
			.cancelBtn('Cancel')
			.okBtnClass('btn btn-success')
			.cancelBtnClass('btn btn-warning')
		 .open()
		  .then( (resultPromise) => {
			  resultPromise.result.then( (result) => {
				var data = {
				  token:this.token,
				  id:plan_id
				}
			 this.busy = this.echexpaymentService.deletePlan(data).subscribe(
				   response => {
					responseData = response;
					this.toastr.success(responseData.message, 'Success!');
					this.getAllPlan();
				   },
				   error => {
					responseData = error;
					this.toastr.error(responseData.error.message, 'Failed!');
				   }
			  );
			}, 
			() => {
			 console.log('Cancel');
			} );
		});
	}

	// ngAfterViewInit(){
	// 	this.renderer.selectRootElement('#initialfocus').focus();
	// }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/plan/plan.component.ts